export const TOOLBOX_TOOLS = [
  {
    id: "buttonToImage",
    name: "按钮成图",
    desc: "把圆形、方形、圆角按钮做成透明底 PNG，可下载或存入私有素材库，方便当图片按钮使用。",
    icon: "el-icon-picture-outline",
    color: "#409eff",
    enabled: true,
  },
];

export const TOOLBOX_GRID_SIZE = 9;
